export const SET_MODAL_FACILITY = 'SET_MODAL_FACILITY';